var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6F6F6F",
  fillRule: "evenodd",
  d: "M10 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m0 6.563a.94.94 0 0 0-.931.828l-.007.11v3.75a.938.938 0 0 0 1.87.109l.005-.11V10A.94.94 0 0 0 10 9.063m0-3.75a.938.938 0 1 0 0 1.874.938.938 0 0 0 0-1.875",
  clipRule: "evenodd"
})));
export default SvgToastInfo;